import { render } from "./FullScreenSmoothSliderComp2.vue?vue&type=template&id=57055cd1&scoped=true"
import script from "./FullScreenSmoothSliderComp2.vue?vue&type=script&lang=js"
export * from "./FullScreenSmoothSliderComp2.vue?vue&type=script&lang=js"

import "./FullScreenSmoothSliderComp2.vue?vue&type=style&index=0&id=57055cd1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57055cd1"]])

export default __exports__